/**
 * Resolve a CASCA do cockpit ANTES do React montar.
 *
 * Mesmo mecanismo do `temaPreview.js` (e pelo mesmo motivo: quem lê o atributo
 * durante o render precisa dele já no <html>, senão o primeiro paint sai com a
 * casca errada e nada re-renderiza).
 *
 * `?ui=crm` liga o layout novo (menu lateral escuro + barra de topo) só neste
 * navegador; `?ui=padrao` volta. Nada guardado = o cockpit de hoje, byte a
 * byte — o deploy é no-op pra quem não pediu.
 *
 * Quando o Bruno aprovar, inverter é trocar o seletor do CSS pra
 * `html:not([data-ui="classico"])`, como já foi feito quando o Papel técnico
 * virou padrão. A saída de emergência sai junto.
 */

const CHAVE = 'cockpit_ui';
// [Bruno 2026-10-02] 'sistema' = a casca do design system Marçal Sistema
// (menu de 9 módulos + Painel de controle novo).
// [Bruno 2026-10-02, tarde] Virou o PADRÃO pra todo mundo: ele abre o cockpit
// pelo atalho da área de trabalho, onde não dá pra pôr `?ui=` no endereço.
// Nada guardado = 'sistema'. Quem prefere o visual de antes grava 'classico'
// (botão "Voltar ao visual atual" ou `?ui=padrao`), e a escolha fica no
// navegador dele. `?ui=sistema` religa.
// [Bruno 2026-10-07] "Deixar apenas a opção de layout mais atualizada": a
// casca Marçal Sistema é a ÚNICA. Sai o botão "Voltar ao visual atual" e o
// `?ui=` deixa de trocar a casca. A escolha antiga guardada no navegador
// ('classico' ou 'crm') é apagada no primeiro carregamento.
const PADRAO = 'sistema';

export function resolverUi() {
  try {
    localStorage.removeItem(CHAVE);
    const u = new URL(window.location.href);
    if (u.searchParams.has('ui')) {
      u.searchParams.delete('ui');
      window.history.replaceState({}, '', u.toString());
    }
  } catch (_) { /* modo privado / storage bloqueado: segue no padrão */ }

  document.documentElement.setAttribute('data-ui', PADRAO);
  return PADRAO;
}
